import CONST from '@/utils/Constants/General';

export const isTabAlreadyLoaded = ({ tabs, searchType }) => {
  let isLoaded = false;
  Array.from(tabs).forEach(tab => {
    if (tab.type === searchType && tab.isLoaded) isLoaded = true;
  });
  return isLoaded;
};

export const normalizeTab = ({ tabs, searchType, t }) => {
  const tabsArray = [];
  const generateContent = ({ type, isActive }) => ({
    isActive,
    isLoaded: isActive,
    type,
    id: `js-search-tab-${type}`,
    countId: `js-search-count-${type}`,
    label: t(`search:search.tab.${type}.label`, { count: tabs[type] }),
  });
  const checkType = ({ type, isActive }) => {
    if (tabs[type] && tabs[type] > 0) {
      tabsArray.push(generateContent({ type, isActive }));
    }
  };

  const types = [
    CONST.SEARCH.TYPE.PRODUCT,
    CONST.SEARCH.TYPE.EDITORIAL,
    CONST.SEARCH.TYPE.FAQ,
    CONST.SEARCH.TYPE.MANUAL,
    CONST.SEARCH.TYPE.RECIPE,
  ];

  Array.from(types).forEach(type => {
    checkType({ type, isActive: searchType === type });
  });

  return tabsArray;
};

export const normalizeModalSuggestionsTerm = data => {
  const suggestions = [];
  Object.keys(data).forEach(key => {
    suggestions.push(...data[key].suggestions);
  });
  return suggestions;
};

export const normalizeModalSuggestionsItems = data => {
  const items = {};
  const totals = {};
  let numItems = 0;
  const filtered = Object.keys(data).filter(item =>
    [CONST.SEARCH.TYPE.EDITORIAL, CONST.SEARCH.TYPE.PRODUCT].includes(item),
  );
  filtered.forEach(key => {
    items[key] = data[key].items;
    totals[key] = data[key].totalResults;
    numItems += data[key].items.length;
  });
  return { items, totals, noItems: numItems === 0 };
};
